<template>
    <div>
        <el-form ref="form" :inline="true" class="query-form" size="mini">
            <!-- <el-form-item label="ASIN:" class="query-form-item">
                <el-input v-model="query.asin" placeholder="请输入ASIN" clearable style="width: 150px;"></el-input>
            </el-form-item> -->
            <el-form-item label="项目组:" class="query-form-item">
                <el-input
                    v-model="query.project_name"
                    placeholder="项目组"
                    clearable
                    style="width: 150px;"
                ></el-input>
            </el-form-item>
            <el-form-item label="站点:" class="query-form-item">
                <el-select
                    v-model="query.state"
                    ref="carrerSelect"
                    style="width: 100px;"
                    size="mini"
                    filterable
                    clearable
                    @change="change"
                    @clear="clearValue"
                >
                    <el-option
                        v-for="item in us_arr"
                        :key="item.us"
                        :label="item.title"
                        :value="item.us"
                        :disabled="item.disabled"
                    >
                        <div class="keywords_arr_div">
                            <icon-svg
                                :icon-class="item.us.toUpperCase()"
                                style="font-size: 24px;margin-right:5px;"
                            ></icon-svg>
                            <span
                                style="font-weight: 700; font-size: 14px;margin-left: 10px;"
                                >{{ item.title }}</span
                            >
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item label="类型: " class="query-form-item">
                <el-select
                    v-model="query.type"
                    @change="getList()"
                    style="width: 120px;"
                    size="mini"
                    filterable
                >
                    <el-option
                        v-for="item in typeArr"
                        :key="item.index"
                        :label="item.title"
                        :value="item.index">
                    </el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item>
                <el-button icon="el-icon-refresh" @click="onReset"></el-button>
                <el-button
                    icon="el-icon-search"
                    type="primary"
                    @click="onSubmit"
                    >查询</el-button
                >
                <el-button type="success" @click="onupload"
                    >上传listing广告数据文件</el-button
                >
                <!-- <el-button type="success" size="mini" @click="antiInternalBidding()" :disabled="disabled">防内部竞价</el-button> -->
            </el-form-item>
            <el-form-item
                label=""
                class="query-form-item"
                style="float:right;margin-right:6px;"
            >
                <el-button size="mini" @click="onDownloadList"
                    >下载列表</el-button
                >
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :data="list"
            :height="tableHeight"
            size="mini"
            ref="multipleTable"
            class="table_content mini_div"
            border
            @sort-change="handleSortChange"
            style="width: 100%;"
        >
            <el-table-column label="ID" width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.id }}</div>
                </template>
            </el-table-column>
            <el-table-column label="项目组" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.project_name }}</div>
                </template>
            </el-table-column>
            <el-table-column label="国家" width="120" align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.state == 'us'">
                        <icon-svg
                            :icon-class="scope.row.state.toUpperCase()"
                            style="font-size: 24px;margin-right:5px;"
                        ></icon-svg>
                        <span>美国</span>
                    </div>
                    <div v-if="scope.row.state == 'de'">
                        <icon-svg
                            :icon-class="scope.row.state.toUpperCase()"
                            style="font-size: 24px;margin-right:5px;"
                        ></icon-svg>
                        <span>德国</span>
                    </div>
                    <div v-if="scope.row.state == 'uk'">
                        <icon-svg
                            :icon-class="scope.row.state.toUpperCase()"
                            style="font-size: 24px;margin-right:5px;"
                        ></icon-svg>
                        <span>英国</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="开始日期" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.start_date || "-" }}</div>
                </template>
            </el-table-column>
            <el-table-column label="结束日期" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.end_date || "-" }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="上传的文件名"
                min-width="150"
                align="center"
            >
                <template slot-scope="scope">
                    <div>{{ scope.row.filename }}</div>
                </template>
            </el-table-column>
            <!-- <el-table-column
                label="状态"
                width="100"
                align="center">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.download_tag == 1" type="success">完成</el-tag>
                    <el-tag v-else-if="scope.row.download_tag == 0" type="info">未完成</el-tag>
                    <el-tag v-else-if="scope.row.download_tag == -1" type="danger">失败</el-tag>
                </template>
            </el-table-column> -->
            <el-table-column
                label="上传时间"
                sortable="custom"
                prop="add_time"
                width="144"
                align="center"
            >
                <template slot-scope="scope">
                    <div>{{ scope.row.add_time.replace(/T/g, " ") }}</div>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="260">
                <template slot-scope="scope">
                    <!-- <el-button style="margin: 5px 0 5px 10px" type="success" size="mini" @click="brandBidding(scope.row)" :disabled="listDisabled">品牌竞价</el-button> -->
                    <el-button
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                        @click="downFile(scope.row)"
                        >下载</el-button
                    >
                    <el-button
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                        @click="onAddPpc(scope.row)"
                        >添加广告优化记录</el-button
                    >
                    <el-button
                        style="margin: 5px 0 5px 10px"
                        type="danger"
                        size="mini"
                        @click="delete_file(scope.row)"
                        >删除</el-button
                    >
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="query.limit"
            :page-sizes="[20, 50, 100]"
            :total="query.total"
            background
            style="float: right;margin-top: 10px; padding-bottom: 30px"
            layout="total, sizes, prev, pager, next"
        >
        </el-pagination>
        <upload
            :visible="ctrl.uploadDialogVisible"
            :us_arr="us_arr"
            :title="'上传lingsting广告数据文件'"
            @close-callback="closeCllback"
        ></upload>
        <DownloadList
            :activeName="activeName"
            :visible="ctrl.DownloadListDialogVisible"
            :title="'下载列表'"
            @close-callback="closeCllback"
        >
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane
                    label="防内部竞价"
                    name="antiInternal"
                    style="padding: 0 25px;"
                >
                    <DownloadView
                        ref="antiInternal"
                        :task_type="1"
                    ></DownloadView>
                </el-tab-pane>
                <el-tab-pane
                    label="品牌竞价"
                    name="brand"
                    style="padding: 0 25px;"
                >
                    <DownloadView ref="brand" :task_type="2"></DownloadView>
                </el-tab-pane>
            </el-tabs>
        </DownloadList>
        <AddPpc
            :visible="ctrl.addPpcDialogVisible"
            :record_id="record_id"
            :title="'添加广告优化记录'"
            @close-callback="closeCllback"
        ></AddPpc>
    </div>
</template>

<script>
import * as api from "@/api/statistics/statistics";
import Upload from "./upload";
import DownloadList from "./downloadList";
import DownloadView from "./downloadView";
import AddPpc from "./addPpc";
import { binary_download } from "../../utils/method";
export default {
    components: { Upload, DownloadList, DownloadView, AddPpc },
    data() {
        return {
            tableHeight: null,
            ctrl: {
                DownloadListDialogVisible: false,
                addPpcDialogVisible: false,
                uploadDialogVisible: false
            },
            typeArr: [
                {
                    index: 1,
                    title: "广告层面"
                },
                {
                    index: 2,
                    title: "逻辑层面"
                }
            ],
            us_arr: [
                {
                    us: "us",
                    title: "美国"
                },
                {
                    us: "uk",
                    title: "英国"
                },
                {
                    us: "de",
                    title: "德国"
                }
            ],
            query: {
                page: 1,
                limit: 20,
                total: 0,
                project_name: "",
                state: "",
                order: "",
                desc: ""
            },
            record_id: 0,
            activeName: "antiInternal",
            list: [],
            disabled: false,
            listDisabled: false,
            loading: false
        };
    },
    created() {
        this.query.asin = this.$route.query.asin;
    },
    mounted() {
        this.tableHeight =
            window.innerHeight - 140 - this.$refs.form.$el.offsetHeight;
        const that = this;
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == "object") {
                    that.tableHeight =
                        window.innerHeight -
                        140 -
                        that.$refs.form.$el.offsetHeight;
                }
            })();
        };
        this.getList();
    },
    watch: {
        tableHeight(val) {
            this.tableHeight = val;
        }
    },
    methods: {
        getList() {
            this.loading = true;
            api.listing_ad_data_show(this.query)
                .then(res => {
                    this.loading = false;
                    if (res.code === 0) {
                        this.list = res.data.detail_list;
                        this.query.total = res.data.total;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        antiInternalBidding() {
            this.disabled = true;
            api.listing_prevent_internal_competition({
                asin: this.query.asin
            })
                .then(res => {
                    this.disabled = false;
                    if (res.code === 0) {
                        this.$message({
                            type: "success",
                            message:
                                "正在分析数据，后续可通过下载列表进行下载文件！"
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.disabled = false;
                });
        },
        brandBidding(data) {
            this.listDisabled = true;
            api.check_brand_ppc({
                asin: this.query.asin,
                record_id: data.id
            })
                .then(res => {
                    this.listDisabled = false;
                    if (res.code === 0) {
                        this.$message({
                            type: "success",
                            message:
                                "正在分析数据，后续可通过下载列表进行下载文件！"
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.listDisabled = false;
                });
        },
        handleSortChange(val) {
            if (val.order == "ascending") {
                this.query.desc = "desc";
                this.query.order = val.prop;
            } else if (val.order == "descending") {
                this.query.desc = "asc";
                this.query.order = val.prop;
            }
            this.getList();
        },
        handleClick(tab) {
            this.$nextTick(() => {
                this.$refs[tab.paneName].getList();
            });
        },
        //重置
        onReset() {
            this.query.project_name = "";
            this.query.state = "";
            this.query.order = "";
            this.query.desc = "";
            this.query.page = 1;
            this.getList();
        },
        //查询
        onSubmit() {
            this.getList();
        },
        change() {
            this.getList();
        },
        clearValue() {
            this.query.state = "";
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        handleSizeChange(val) {
            this.query.limit = val;
            this.getList();
        },
        //上传文件
        onupload() {
            this.ctrl.uploadDialogVisible = true;
        },
        //下载列表
        onDownloadList() {
            this.ctrl.DownloadListDialogVisible = true;
            this.$nextTick(() => {
                this.$refs[this.activeName].getList();
            });
        },
        downFile(row) {
            if (!row.import_path) {
                return this.$message({
                    type: "error",
                    message: "无法下载！"
                });
            }
            binary_download(
                "/apis/v1/common_file_export_by_path",
                "post",
                {},
                {
                    file_path: row.import_path
                },
                "application/vnd.ms-excel",
                row.filename
            );
        },
        //添加广告优化记录
        onAddPpc(data) {
            this.record_id = data.id;
            this.ctrl.addPpcDialogVisible = true;
        },
        //删除
        delete_file(data) {
            this.$confirm(`确定要删除这条记录吗?`, {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    api.listing_ad_data_delete({
                        id: data.id
                    })
                        .then(res => {
                            if (res.code === 0) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功"
                                });
                                this.getList();
                            } else {
                                this.$message({
                                    type: "error",
                                    message: res.message
                                });
                            }
                        })
                        .catch(res => {
                            this.$message({
                                type: "error",
                                message: res.message
                            });
                        });
                })
                .catch(() => {});
        },
        // 关闭弹窗回调
        closeCllback(isshow) {
            this.ctrl.uploadDialogVisible = false;
            this.ctrl.addPpcDialogVisible = false;
            this.ctrl.DownloadListDialogVisible = false;
            isshow == true && this.getList();
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
.mini_div .el-button--mini {
    padding: 5px 5px !important;
}
/deep/ .el-table__expanded-cell {
    padding: 0 0 !important;
}
</style>
